import React from 'react';
import { Controller, RegisterOptions, useFormContext } from 'react-hook-form';
import { FormControl, FormHelperText, InputLabel, MenuItem, Select, SelectProps } from '@mui/material';

type Select = {
  type: 'select';
  name: string;
  label: string;
  options: object;
  rule?: RegisterOptions;
};

type InputPartialProps = Omit<SelectProps, keyof Select>;

export type CustomSelectProp = Select & InputPartialProps;

const CustomSelect: React.FC<Select & InputPartialProps> = ({ name, options, label, rule, ...selectProps }) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      rules={rule}
      defaultValue={''}
      render={({ field, fieldState }) => (
        <FormControl fullWidth error={!!fieldState.error}>
          <InputLabel id={name}>{label}</InputLabel>
          <Select fullWidth labelId={name} label={label} {...field} {...selectProps}>
            {Object.keys(options).map((key) => (
              <MenuItem key={options[key as keyof typeof options]} value={options[key as keyof typeof options]}>
                {key}
              </MenuItem>
            ))}
          </Select>
          <FormHelperText>{fieldState.error?.message}</FormHelperText>
        </FormControl>
      )}
    />
  );
};

export default CustomSelect;
